
import {
  ref, defineComponent, onMounted, watch,
} from 'vue';
import { postRequest, } from '@/request/request';
import { Cascader, } from 'ant-design-vue';

export default defineComponent({
  components: {
    Cascader,
  },
  props: {
    regionId: {
      type: String,
      required: true,
      default: '',
    },
    // regionId回显最小区域级别
    endLevel: {
      type: Number,
      default: 4,
    },
    region: {
      type: String,
      // 查询范围   'ALL'或者regionId值
      default: 'ALL',
    },
    addItems: {
      type: Array,
      // eg:[{ name: '全部', id: '', },]
      default: () => [],
    },
  },
  setup (props, { emit, }) {
    const regionValues = ref<string[]>([]);
    const selectRegion = ref<string>('');
    const areaOpts = ref<any[]>([]);
    let startLevel = 1;
    // 不同级别regionId有效位数
    const validLength = {
      1: 2,
      2: 4,
      3: 6,
      4: 9,
    };

    // 根据配置项处理数据
    const dealDataByOpts = (data:any[]) => {
      const { addItems, } = props;
      const newData = data;

      if (addItems && addItems.length) {
        newData.unshift(...addItems);
      }

      return newData;
    };

    // 获取区域选项数据
    const loadAreaOpts = async (region:string) => {
      const isAll = region === 'ALL';
      const params = isAll ? { scope: 'ALL', } : { scope: '',regionId: region, };
      const res = await postRequest('/openUser/queryAllRegion',params);
      const list = isAll ? res?.data : res?.data[0]?.children;

      startLevel = list?.[0]?.regionLevel || 1;
      const data = dealDataByOpts(list || []);

      areaOpts.value = data;
    };

    const getValsByRegionId = (opts:any[],regionId:string,level:number,targetLevel:number) :string[] => {
      if (level > targetLevel || !opts || opts.length === 0) return [];
      const nextOpts = opts.find((item:any) => {
        // 判断当前级别字符是否相等
        const isSame = item?.id.substring(0,validLength[level]) === regionId.substring(0,validLength[level]);

        return isSame;
      });

      if (!nextOpts) return [];

      const { id,children, } = nextOpts || {};
      const childrenIds :string[] = getValsByRegionId(children,regionId,level + 1,targetLevel) || [];

      return [id,...childrenIds,];
    };

    const handleChange = (value: any,e:any) => {
      const { children,...node } = e[e.length - 1] || {};

      selectRegion.value = value[value.length - 1] || '';

      emit('update:regionId',selectRegion.value);
      emit('change',node);
    };

    // 根据regionId设置regionValues
    const setRegionValues = (val:string) => {
      if (val) {
        regionValues.value = getValsByRegionId(areaOpts.value,val,startLevel,props.endLevel);
      } else {
        regionValues.value = [];
      }
    };

    watch(() => props.regionId,(val:any) => {
      if (val === selectRegion.value) return;
      selectRegion.value = val;
      setRegionValues(val);
    });

    onMounted(() => {
      const { region,regionId, } = props;

      selectRegion.value = regionId;

      loadAreaOpts(region).then(() => {
        setRegionValues(regionId);
      });
    });

    return {
      regionValues,
      areaOpts,

      handleChange,
    };
  },
});
